const FileSourceType = {
  Unknown: "UNKNOWN",
  AuditLogDownloadFile: "AUDIT_LOG_DOWNLOAD_FILE",
  CustomerAttachment: "CUSTOMER_ATTACHMENT",
  CustomerLogoImage: "CUSTOMER_LOGO_IMAGE",
  CustomerSignature: "CUSTOMER_SIGNATURE",
  CustomerTitleImage: "CUSTOMER_TITLE_IMAGE",
  DependentFamilyAttachment: "DEPENDENT_FAMILY_ATTACHMENT",
  Digicon: "DIGICON",
  DigiconPdfBulkDownloadFile: "DIGICON_PDF_BULK_DOWNLOAD_FILE",
  ImpactOperation: "IMPACT_OPERATION",
  ItassetAttachment: "ITASSET_ATTACHMENT",
  ItassetAssetImage: "ITASSET_ASSET_IMAGE",
  InsuranceTermsAgreementPdf: "INSURANCE_TERMS_AGREEMENT_PDF",
  SpendingEvidenceAttachmentFile: "SPENDING_EVIDENCE_ATTACHMENT_FILE",
  SpendingEvidenceExcel: "SPENDING_EVIDENCE_EXCEL",
  NoticeAttachment: "NOTICE_ATTACHMENT",
  OneOnOneMeetingNoteAttachment: "ONE_ON_ONE_MEETING_NOTE_ATTACHMENT",
  PayrollAttachment: "PAYROLL_ATTACHMENT",
  PayrollTempToBeMerged: "PAYROLL_TEMP_TO_BE_MERGED",
  PayrollMergedFile: "PAYROLL_MERGED_FILE",
  RecruitingCandidatesDownloadFile: "RECRUITING_CANDIDATES_DOWNLOAD_FILE",
  RecruitingCandidateAttachment: "RECRUITING_CANDIDATE_ATTACHMENT",
  RecruitingCandidateSelfAttachment: "RECRUITING_CANDIDATE_SELF_ATTACHMENT",
  RecruitingCommunicationAttachment: "RECRUITING_COMMUNICATION_ATTACHMENT",
  RecruitingCandidateAttachmentBulkDownloadFile: "RECRUITING_CANDIDATE_ATTACHMENT_BULK_DOWNLOAD_FILE",
  ReviewAnswerAttachment: "REVIEW_ANSWER_ATTACHMENT",
  TimeOffDocument: "TIME_OFF_DOCUMENT",
  UserAttachment: "USER_ATTACHMENT",
  UserDocument: "USER_DOCUMENT",
  UserDocumentBundle: "USER_DOCUMENT_BUNDLE",
  CareerAttachment: "CAREER_ATTACHMENT",
  UserCertificate: "USER_CERTIFICATE",
  UserProfileImage: "USER_PROFILE_IMAGE",
  UserProfileCoverImage: "USER_PROFILE_COVER_IMAGE",
  UserSignature: "USER_SIGNATURE",
  CompetencyUpdateExcel: "COMPETENCY_UPDATE_EXCEL",
  WorkflowEngineDefinition: "WORKFLOW_ENGINE_DEFINITION",
  WorkflowInEditorFile: "WORKFLOW_IN_EDITOR_FILE",
  WorkflowLegacyInEditorFile: "WORKFLOW_LEGACY_IN_EDITOR_FILE",
  WorkflowTaskAttachment: "WORKFLOW_TASK_ATTACHMENT",
  WorkflowTaskAttachmentBulkDownloadFile: "WORKFLOW_TASK_ATTACHMENT_BULK_DOWNLOAD_FILE",
  WorkflowTaskPdf: "WORKFLOW_TASK_PDF",
  WorkflowTaskBulkDownloadFile: "WORKFLOW_TASK_BULK_DOWNLOAD_FILE",
  WorkflowTaskExcel: "WORKFLOW_TASK_EXCEL",
  WorkflowTemplateAttachment: "WORKFLOW_TEMPLATE_ATTACHMENT",
  YearendDependentFamilyAttachment: "YEAREND_DEPENDENT_FAMILY_ATTACHMENT",
  YearendDeductionAttachment: "YEAREND_DEDUCTION_ATTACHMENT",
  YearendDeductionPdf: "YEAREND_DEDUCTION_PDF",
  YearendWithholdingTempToBeMerged: "YEAREND_WITHHOLDING_TEMP_TO_BE_MERGED",
  YearendMergedFile: "YEAREND_MERGED_FILE"
};

export { FileSourceType };
//# sourceMappingURL=file-source-type.mjs.map
